import React, { useMemo } from 'react';
import { View } from 'react-native';
import { rem } from 'design-system';
import { IconPaperUpload, IconSmartRule } from 'design-system/icons';
import Text from 'design-system/Text';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import { selectUserId } from 'reducers/selectors';
import { selectIsDefaultSpace } from 'features/spaces/reducers/selectors';
const TransactionAutoCreated = ({ transaction, isPill }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    const myId = useAppSelector(selectUserId);
    const isDefaultSpace = useAppSelector(selectIsDefaultSpace);
    const isMyTransaction = useMemo(() => isDefaultSpace || myId === transaction?.userId, [isDefaultSpace, myId, transaction?.userId]);
    const size = isPill ? 20 : 16;
    if (transaction.wasImportedFromFile && isMyTransaction) {
        return (<View style={[styles.container, isPill && styles.pill]}>
        <IconPaperUpload colorKey="positive" width={size} height={size} alt/>
        <Text TextThin-14 color={colors.status.positive}>
          {isPill ? 'Imported from file' : 'Imported'}
        </Text>
      </View>);
    }
    if (transaction.smartRuleInfo &&
        'smartRuleId' in transaction.smartRuleInfo &&
        isMyTransaction) {
        return (<View style={[styles.container, isPill && styles.pill]}>
        <IconSmartRule colorKey="positive" size={size}/>
        <Text TextThin-14 color={colors.status.positive}>
          {isPill ? 'Created by a Smart rule' : 'Auto created'}
        </Text>
      </View>);
    }
    return null;
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: rem(8),
    },
    pill: {
        alignSelf: 'center',
        borderRadius: rem(42),
        backgroundColor: colors.elements.positiveLight,
        paddingVertical: rem(8),
        paddingHorizontal: rem(16),
        marginBottom: rem(12),
    },
}));
export default TransactionAutoCreated;
